import { AxiosAdapter } from '../../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getClaims({ status, page, pharmacy, rut, claimId, claimType, trxId }) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/claim/search-by-status/${Enviroment.LANGUAGE}/page/${page}`,
			params: { rut: rut, status: status, claim_id: claimId, type: claimType, pharmacy: pharmacy, trx_id: trxId },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async getPharmacies() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FRONT_COMMON}/pharmacies/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
